<template>
  <v-container>
    <div><router-link to="./">[Home]</router-link></div>
    <div><router-link to="./h">[HelloWorld]</router-link></div>
    <div>** Experimental **</div>
    <v-btn v-on:click="countup(1)"> +1 </v-btn><br/>
    <v-btn v-on:click="countup(2)"> +2 </v-btn><br/>
    <input v-model="testCount">
    <v-row class="text-center">
      <v-col cols="12">
        <div>
          <v-btn id="listMIDIDevices01" v-on:click="startMidiConnection()">listMIDIDevices01</v-btn>
        </div>
        <div>
          <v-btn id="reqDeviceId01" v-on:click="requestMidiDeviceId()">reqDeviceId01</v-btn>
        </div>
        <div>
          <input id="patchNumber01" type="number" min="0" max="99" step="1" v-model="patchNumber01" style="width:50px; text-align:center">
          <v-btn id="reqPatch01" v-on:click="requestOnePatch()">reqPatch01</v-btn>
        </div>
        <br>
        <div>
          <input id="patchName01" type="text" style="width:250px; text-align:left; padding:2px;" v-model="patchName01">
          <v-btn id="sendPatch01" v-on:click="sendOnePatch()">Send Patch</v-btn>
        </div>
        <div>
          <webaudio-knob id="knob-1" src="./images/webautio-ctrls/knobs/LittlePhatty.png" diameter="64" min="0" max="100"></webaudio-knob>
          <webaudio-knob id="knob-2" src="./images/webautio-ctrls/knobs/JP8000.png" diameter="64" min="0" max="100"></webaudio-knob>
          <webaudio-knob id="knob-3" src="./images/webautio-ctrls/knobs/knob_64_white1.png" diameter="64" min="0" max="100"></webaudio-knob>
          <webaudio-knob id="knob-4" src="./images/webautio-ctrls/knobs/Knob_18.png" diameter="64" min="0" max="100"></webaudio-knob>
          <webaudio-knob id="knob-5" src="./images/webautio-ctrls/knobs/ANGEL_Sewage_62x62knob.png" diameter="64" min="0" max="100"></webaudio-knob>
          <webaudio-knob id="knob-6" src="./images/webautio-ctrls/knobs/simplegray.png" diameter="64" min="0" max="100"></webaudio-knob>

          <webaudio-slider id="slider10" direction="vert" colors="#fff;#444;#fff"></webaudio-slider>

          <webaudio-switch id="sw1" colors="#0f0;#fff;#fff"></webaudio-switch>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
 export default {
   name: 'Experimental',
   methods: {
     countup: function(num=1) {
       this.$store.commit('onTestChange', num)
     },
     startMidiConnection: async function() {
       console.log(this.$data.globalVar.libs.listMIDIDevices, this.$libs)
       const requestMIDIAccessOption = {sysex: true}
       const ret_midi = await this.$data.globalVar.libs.listMIDIDevices(requestMIDIAccessOption)
       if (ret_midi.success) {
         console.log(ret_midi.devices)
         this.$data.globalVar.libs.ewi4ksd.setMidiDevice('input', ret_midi.devices.inputs[0])
         this.$data.globalVar.libs.ewi4ksd.setMidiDevice('output', ret_midi.devices.outputs[0])
         console.log(this.$data.globalVar.libs.ewi4ksd.getMidiDevice())
       } else {
         console.error(this.$data.globalVar.libs.ewi4ksd.error_msg)
       }
     },
     requestMidiDeviceId: function() {
       this.$data.globalVar.libs.ewi4ksd.requestDeviceId()
     },
     requestOnePatch: function() {
       const patchNo = Number(this.$data.patchNumber01)
       console.log(patchNo)

       const self = this
       function onMidiMessage() {
         const patch = self.$data.globalVar.libs.ewi4ksd.getOneStoredPatch(patchNo)
         self.$data.patchName01 = patch.decoded.patchNameDecoded.replace(/ /g, '')
       }
       this.$data.globalVar.libs.ewi4ksd.fetchOnePatch(patchNo, onMidiMessage.bind(this.$data.globalVar.libs.ewi4ksd))

       const patchName = "TAKARAJIMA                   "
       const patchNameEncoded = this.$data.globalVar.libs.ewi4ksd.encodePatchName(patchName)
       console.log('[ENCODED PATCHNAME]', this.$data.globalVar.libs.ewi4ksd.encodePatchName(patchName), patchNameEncoded.length)
     },
     sendOnePatch() {
       const newPatchName =  this.$data.patchName01
       const patchNo = Number(this.$data.patchNumber01)
       try {
         this.$data.globalVar.libs.ewi4ksd.setOneEditPatchFromStoredPatch(patchNo)
         console.log(this.$data.globalVar.libs.ewi4ksd.getOneEditPatch(patchNo))
         const encodedPatchName = this.$data.globalVar.libs.ewi4ksd.encodePatchName(newPatchName)
         const newDecodedPatch = this.$data.globalVar.libs.ewi4ksd.updateOneEditPatch(patchNo, 'patchName', encodedPatchName)
         const newEncodedPatch = this.$data.globalVar.libs.ewi4ksd.encodeOnePatch(newDecodedPatch.decoded)
         this.$data.globalVar.libs.ewi4ksd.sendOnePatch(newEncodedPatch, onMidiMessage)
       } catch (err) {
         console.error(err)
       }
       function onMidiMessage(event) {
         if (event.data[0]!=0xe0) {
           console.log(event.data)
         }
       }
     }
   },
   computed: {
     testCount: {
       get () {
         console.log()
         return this.$store.getters.getTestCount()
       },
       //set (value) {
       //this.$store.commit('onTestChange', value)
       //}
     }
   },
   data: () => ({
     patchNumber01: 1,
     patchName01: '',
   }),
 }
</script>
